import { render, staticRenderFns } from "./RegisterData.vue?vue&type=template&id=8e0c0e60&scoped=true"
import script from "./RegisterData.vue?vue&type=script&lang=js"
export * from "./RegisterData.vue?vue&type=script&lang=js"
import style0 from "./RegisterData.vue?vue&type=style&index=0&id=8e0c0e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0c0e60",
  null
  
)

export default component.exports